import StylesTab from './StylesTab';

export default StylesTab;
